//  Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved.
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {throwError} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ConfigurationService} from './configuration-service';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BaseService {

    constructor(
        protected readonly http: HttpClient,
        protected readonly translate: TranslateService,
        protected readonly configurationService: ConfigurationService,
    ) { }

    getUrl(suffix: string, query: string[][] = []) {
        const queryString = query.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
        const baseUrl = `${this.configurationService.apiUrl}${suffix}`;
        if (!!queryString) {
            return `${baseUrl}?${queryString}`;
        }
        return baseUrl;
    }

    handleError(errResponse: HttpErrorResponse | any): any {
        if ((errResponse instanceof HttpErrorResponse) && errResponse?.error?.status) {
            return new Promise((resolve, reject) => {
                this.translate.get(errResponse.error.status).subscribe(
                    (translated) => reject(translated),
                    (err) => reject('Server Error')
                );
            });
        }
        return throwError(errResponse.error || 'Server error');
    }

}
